<template>
  <ColumnContent :title="t('Регионы', options)">
    <a
      v-for="region in context.regions"
      :key="region.translit"
      class="d-table text--text link-decoration-none mb-4 text-body-1"
      data-qa="region-link"
      :href="`https://${context.request.country.site.domain}/${region.translit}/`"
    >
      {{ transDynamic(region, `name,${language},${needTranslate}`) }}
    </a>
  </ColumnContent>
</template>

<script setup lang="ts">
import I18NextVue from 'i18next'
import { useContextStore } from 'src/store'
import { ColumnContent } from 'src/layouts'
import { ContextStore } from 'src/components/pages/regions/types'
import transDynamic from 'djanjucks/filters/transDynamic'

const { context }: ContextStore = useContextStore()
// ToDo Заменить hardcode URLs в компоненте (такого URL нет в 'urls-pd.json')

const { t, language } = I18NextVue
const options = { ns: language }

const needTranslate = context.feature_flags.pd_l10n_footer_pages
</script>
